import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const InfoText = ({ content }) => {
    return (
        <div className={styles.infoText}>
            {content?.voteList?.overview?.pageDesc}
        </div>
    );
};

InfoText.propTypes = {
    content: PropTypes.object,
};

export default InfoText;
